import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import buildCylindoFrameOneUrl from 'commons/buildCylindoFrameOneUrl';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import JBImage from 'components/essentials/JBImage';
import usePDPCylindoViewer from 'data-hooks/usePDPCylindoViewer';
import useIsBrowser from 'hooks/useIsBrowser';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import usePDPDeepLinkVariantMismatch from '../hooks/usePDPDeepLinkVariantMismatch';
import usePdpShowStickyButtons from '../state/context/usePdpShowStickyButtons';
import PDPAddToBagSection from '../PDPAddToBagSection';
import PDPPriceSection from '../PDPPriceSection';
import PDPLeadTimeUI from '../PDPNameSection/PDPLeadTimeUI';
import PDPStickySummaryOptions from './PDPStickySummaryOptions';

// Stands in for the sticky price row PDPNameSection turns off in the layout revamp
const PDPStickySummaryBarInner = t0 => {
  const $ = _c(35);
  const {
    slug,
    productCylindoHeroImage: t1
  } = t0;
  const productCylindoHeroImage = t1 === undefined ? null : t1;
  const isBrowser = useIsBrowser();
  const showStickyButtons = usePdpShowStickyButtons();
  const {
    data: basicDetails
  } = usePDPBasicDetails();
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      deferCylindoFetch: true
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    cylindoFeatures,
    isCylindoAvailable,
    isUpholsteryUnresolved
  } = usePDPCylindoViewer(t2);
  const isCylindoProduct = !!basicDetails?.custom_properties?.cylindo_product;
  const t3 = productCylindoHeroImage?.defaultUpholsteryValue;
  const t4 = productCylindoHeroImage?.defaultOrientation;
  let t5;
  if ($[1] !== t3 || $[2] !== t4) {
    t5 = {
      defaultUpholsteryValue: t3,
      defaultOrientation: t4
    };
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const isUrlDeepLinkMismatch = usePDPDeepLinkVariantMismatch(t5);
  let t6;
  if ($[4] !== basicDetails || $[5] !== cylindoFeatures || $[6] !== isCylindoAvailable || $[7] !== isUpholsteryUnresolved) {
    t6 = isCylindoAvailable && !isUpholsteryUnresolved && Object.keys(cylindoFeatures).length ? buildCylindoFrameOneUrl({
      productId: basicDetails.id,
      features: cylindoFeatures
    }) : null;
    $[4] = basicDetails;
    $[5] = cylindoFeatures;
    $[6] = isCylindoAvailable;
    $[7] = isUpholsteryUnresolved;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const selectedCylindoSrc = t6;
  const cylindoSrc = selectedCylindoSrc || !isUrlDeepLinkMismatch && productCylindoHeroImage?.src;
  const heroSrc = isCylindoProduct && isUrlDeepLinkMismatch ? null : basicDetails?.hero_images?.[0]?.img?.url;
  const t7 = !showStickyButtons;
  let t8;
  if ($[9] !== showStickyButtons || $[10] !== t7) {
    t8 = classNames("fixed inset-x-0 top-0 z-[999] bg-white shadow-md transition-[opacity,visibility] ease-in max-[1023px]:hidden", {
      "opacity-0 invisible pointer-events-none": t7,
      "opacity-100": showStickyButtons
    });
    $[9] = showStickyButtons;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== cylindoSrc || $[13] !== heroSrc) {
    t9 = cylindoSrc ? <img src={cylindoSrc} alt="" data-xc="PDPStickySummaryImage" width="112" height="75" className="h-[75px] w-[112px] object-contain flex-none" /> : heroSrc && <JBImage data-xc="PDPStickySummaryImage" src={heroSrc} width="112" height="75" className="h-[75px] w-[112px] object-contain flex-none" />;
    $[12] = cylindoSrc;
    $[13] = heroSrc;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const t10 = basicDetails?.name;
  let t11;
  if ($[15] !== t10) {
    t11 = <div className="text-base font-bold text-gray" data-xc="PDPStickySummaryName">{t10}</div>;
    $[15] = t10;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <PDPPriceSection />;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t11) {
    t13 = <div className="flex-none">{t11}{t12}</div>;
    $[18] = t11;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== slug) {
    t14 = <PDPStickySummaryOptions slug={slug} className="border-0 border-l border-solid border-gray-light6 pl-8" />;
    $[20] = slug;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <PDPAddToBagSection stickyDesktopButtonOnly={true} keepAddToBagLabel={true} />;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== isBrowser) {
    t16 = isBrowser && <PDPLeadTimeUI mode="pdp" />;
    $[23] = isBrowser;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== t16) {
    t17 = <div className="ml-auto w-[400px] flex-none text-center">{t15}{t16}</div>;
    $[25] = t16;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== t13 || $[28] !== t14 || $[29] !== t17 || $[30] !== t9) {
    t18 = <FixedWidthContainer wide={true} className="flex items-center gap-8 !py-3">{t9}{t13}{t14}{t17}</FixedWidthContainer>;
    $[27] = t13;
    $[28] = t14;
    $[29] = t17;
    $[30] = t9;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== t18 || $[33] !== t8) {
    t19 = <div data-xc="PDPStickySummaryBar" className={t8}>{t18}</div>;
    $[32] = t18;
    $[33] = t8;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  return t19;
};
PDPStickySummaryBarInner.propTypes = {
  slug: PropTypes.string,
  productCylindoHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    defaultUpholsteryValue: PropTypes.string,
    defaultOrientation: PropTypes.string
  })
};

// Null fallback: a loader here would sit in normal flow and push the page down
const PDPStickySummaryBar = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <SuspenseWithLoader fallback={null}><PDPStickySummaryBarInner {...props} /></SuspenseWithLoader>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default PDPStickySummaryBar;